export type MutationLogKey =
  | 'provider'
  | 'correlationId'
  | 'channelId'
  | 'userId'
  | 'status'
  | 'code'
  | 'actionId'
  | 'idempotencyKey'
  | 'widgetType';

export type MutationLogMetadata = Partial<Record<MutationLogKey, string>>;

const ALLOWED_KEYS = new Set<MutationLogKey>([
  'provider',
  'correlationId',
  'channelId',
  'userId',
  'status',
  'code',
  'actionId',
  'idempotencyKey',
  'widgetType',
]);

function coerceValue(value: unknown): string | undefined {
  if (typeof value === 'string') {
    return value;
  }
  if (typeof value === 'number') {
    return value.toString();
  }
  return undefined;
}

/**
 * Restricts log metadata to approved keys with stringified values.
 */
export function sanitizeMutationMetadata(
  metadata?: MutationLogMetadata,
  overrides?: MutationLogMetadata
): MutationLogMetadata {
  const context: MutationLogMetadata = {};

  for (const source of [metadata, overrides]) {
    if (!source) continue;
    for (const [key, value] of Object.entries(source)) {
      if (!ALLOWED_KEYS.has(key as MutationLogKey)) {
        continue;
      }
      const coerced = coerceValue(value);
      if (coerced !== undefined) {
        context[key as MutationLogKey] = coerced;
      }
    }
  }

  return context;
}
